<ng-template #itemTemplate let-location="item">
  <div class="content w-100 pe-2"
       [class.nothing-found]="location.nothingFound"
       [class.disabled]="location.nothingFound ">
    <ng-container *ngIf="location.nothingFound">
      <span [translate]="'locationSearchBar.nothingFound'"></span>
    </ng-container>

    <ng-container *ngIf="!location.nothingFound">
      <i class="text-muted"
         [class.icon-map-marker]="location.isCity"
         [class.icon-shop]="!location.isCity"></i>
      {{ location.label || location.name }}
    </ng-container>
  </div>
</ng-template>
<div class="search-location"
     [class.blinking-cursor]="showBlinkingCursor && !isFocused"
     [class.bordless]="bordless">
  <ui-search-bar
    [autoFocus]="autoFocus"
    [itemsSourceFn]="searchLocation.bind(this)"
    [selectedItem]="selectedLocation"
    [itemTemplate]="itemTemplate"
    [placeholder]="placeholder"
    [styleType]="styleType"
    [showLoading]="showLoading"
    (onSelected)="onSelected($event)"
    (showDropdown)="showDropdown = $event"
    (onInputFocused)="onSearchBarFocused.emit(); setFocused()">
  </ui-search-bar>
</div>
